import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import CannedBeansProduct from 'models/CannedBeansProduct'

import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState, saltContentOptions } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { isNotNumericDecimal } from 'context/Utilities'

const CannedBeansPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  // eslint-disable-next-line no-unused-vars
  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSelect, onChange, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const { category, subCategory, SaltContent, PBContainerSize } = current
      setPackaging({
        category,
        subCategory,
        SaltContent: {
          value: SaltContent || '',
          label: SaltContent.length > 0 ? SaltContent : 'Salt Content',
        },
        PBContainerSize,
      })
    } else if (!updating) {
      setCurrent(CannedBeansProduct)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Salt Content {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={saltContentOptions}
          name="SaltContent"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Salt Type'}
          onChange={([selected]) => {
            setSelect(selected, 'SaltContent')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="SaltContent"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>Size {asterisk}</strong>
        </p>
        <Controller
          as={Input}
          name="PBContainerSize"
          placeholder={'15 - 16 ounces'}
          control={methods.control}
          rules={{
            validate: PBContainerSize =>
              PBContainerSize >= 15 && PBContainerSize <= 16,
            maxLength: {
              value: 5,
              message: '⚠ Size exceeds 5 characters.',
            },
          }}
          onKeyDown={e => {
            if (isNotNumericDecimal(e.key)) {
              e.preventDefault()
            }
          }}
          onChange={([event]) => {
            onChange(event)
            return event
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="PBContainerSize"
            message={'⚠ Size must be between 15 - 16 ounces.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
      </Col>
    </Row>
  )
}

export default CannedBeansPackage
